<template>
  <Form :ref="'form'+current" :model="form" :rules="rules" :label-width="165">
    <Row :gutter="16">
      <Col span="12" v-if="form.applicantMaritalStatus == $store.state.maritalStatusSet['初婚']||form.applicantMaritalStatus == $store.state.maritalStatusSet['再婚']">
      <FormItem label="上传持证人结婚证原件">
        <Row :gutter="16">
          <Col span="24">
          <div class="line_area">
            <!-- 已上传图片 -->
            <div class="fileList" v-if="form.applicantMarriageCertificateGuid">
              <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
              <span class="pos">
                <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantMarriageCertificateGuid" />
                <i class="img_magnify">
                  <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantMarriageCertificateGuid)" type="ios-eye" />
                </i>
              </span>
              <!-- </template> -->
            </div>
            <div class="fileList" v-else>
              <span class="pos">
                <span class="img">
                  <span class="uploadImageNo">
                    <Icon type="ios-image" size="30" />
                  </span>
                </span>
              </span>
            </div>
          </div>
          </Col>
        </Row>
      </FormItem>
      </Col>
      <template v-if="form.applicantMaritalStatus == $store.state.maritalStatusSet['离异']">
        <Col span="24">
        <FormItem :label="'离婚证'">
          <Row :gutter="16">
            <Col span="24">
            <div class="line_area">
              <!-- 已上传图片 -->
              <div class="fileList" v-if="form.applicantDivorceCertificateGuid">
                <!-- <template v-for="(img, img_i) in form.personnelIDCardBackGuid"> -->
                <span class="pos">
                  <img class="img uploadImage" :src="$baseURL+'/file/cover/'+ form.applicantDivorceCertificateGuid" />
                  <i class="img_magnify">
                    <Icon size="26" class="ico" color="#ffffff" @click="handleView(form.applicantDivorceCertificateGuid)" type="ios-eye" />
                    <Icon size="26" class="ico" color="#ffffff" @click="handleRemove(0,'applicantDivorceCertificateGuid','applicantDivorceCertificateGuid')" type="ios-trash-outline" />
                  </i>
                </span>
                <!-- </template> -->
              </div>
              <div class="fileList" v-else>
                <span class="pos">
                  <span class="img">
                    <span class="uploadImageNo">
                      <Icon type="ios-image" size="30" />
                    </span>
                  </span>
                </span>
              </div>
            </div>
            </Col>
          </Row>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'离婚协议'">
          <div class="_link" v-for="item in form.applicantDivorceSettlementGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.applicantDivorceSettlementGuidListPreview.length<1">无</span>

        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'法院判决材料'" prop="applicantMarriageCourtJudgmentGuidList">
          <div class="_link" v-for="item in form.applicantMarriageCourtJudgmentGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.applicantMarriageCourtJudgmentGuidListPreview.length<1">无</span>

        </FormItem>
        </Col>
        <Col span="24">
        <FormItem :label="'法院调解书'" prop="applicantMarriageCourtMediationLetterGuidList">
          <div class="_link" v-for="item in form.applicantMarriageCourtMediationLetterGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.applicantMarriageCourtMediationLetterGuidListPreview.length<1">无</span>

        </FormItem>
        </Col>
      </template>
      <template v-if="form.applicantMaritalStatus === $store.state.materiaBasicData.maritalStatusSet['丧偶']">
        <Col span="24">
        <FormItem :label="'死亡证明'">
          <div class="_link" v-for="item in form.applicantSpouseDeathCertificateGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.applicantSpouseDeathCertificateGuidListPreview.length<1">无</span>
        </FormItem>
        </Col>
      </template>
      <Col span="24" v-if="form.applicantMaritalStatus != $store.state.maritalStatusSet['初婚']">
      <FormItem label="历史婚姻材料">
        <div class="_link" v-for="item in form.applicantHistoricalMarriageFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
          <Icon :type="item.name | fileType" />
          {{item.name}}
        </div>
        <span class='_noLink' v-if="form.applicantHistoricalMarriageFileGuidListPreview.length<1">无</span>
        <div class="notice">
          <div>
            请完整提交每段婚姻材料：
            <div>1、离婚：离婚证、离婚协议书或法院调解书、判决书；</div>
            2、丧偶：死亡证明。
          </div>
        </div>
      </FormItem>

      </Col>
    </Row>

  </Form>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },

  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      //   form: { id: 'ywlsh_12356789', kh: '新开户', sfzzm: [] },
      uploadData: { readIdInfo: true },
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {
        idCardFrontGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        idCardBackGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        name: [{ required: true, message: '请输入', trigger: 'change' }],
        idCardNo: [
          { required: true, message: '请输入', trigger: 'change' },
          {
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确的身份证号',
            trigger: 'blur',
          },
        ],
        registeredResidenceType: [
          { required: true, message: '请选择', type: 'number', trigger: 'change' },
        ],
        residenceBookletMainPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        residenceBookletSelfPageGuid: [{ required: true, message: '请上传', trigger: 'change' }],
        applicantMarriageCertificateGuid: [
          { required: true, message: '请上传', trigger: 'change' },
        ],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //上一步
      let _this = this

      if (name === null) {
        this.$emit('next', _this.appInfoDataType['申请人基本信息'])
        return
      }
      //下一步

      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        let formSubmit = true
        if (_this.form.applicantMaritalStatus === _this.$store.state.maritalStatusSet['离异']) {
          formSubmit = false
          //离婚证+离婚协议
          if (
            _this.form.applicantDivorceCertificateGuid &&
            Array.isArray(_this.form.applicantDivorceSettlementGuidList) &&
            _this.form.applicantDivorceSettlementGuidList.length > 0
          ) {
            formSubmit = true
          }
          //法院判决书
          if (
            Array.isArray(_this.form.applicantMarriageCourtJudgmentGuidList) &&
            _this.form.applicantMarriageCourtJudgmentGuidList.length > 0
          ) {
            formSubmit = true
          }
          //法院调解书
          if (
            Array.isArray(_this.form.applicantMarriageCourtMediationLetterGuidList) &&
            _this.form.applicantMarriageCourtMediationLetterGuidList.length > 0
          ) {
            formSubmit = true
          }
        }
        if (!formSubmit) {
          this.$Message.error({
            content: '离婚证与离婚协议、法院判决书、法院调解书必须上传一个',
            background: true,
            duration: 6,
          })
          return
        }
        let submiteUrl = '/api/services/app/JZZJFApi/SaveApplicantMarriageInfo'
        if (
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['初婚'] ||
          this.form.applicantMaritalStatus == this.$store.state.maritalStatusSet['再婚']
        ) {
          _this.$emit('next', _this.appInfoDataType['配偶信息'], submiteUrl)
          return
        }
        if (_this.form.isChildrenEnjoyTreatment) {
          _this.$emit('next', _this.appInfoDataType['子女信息'], submiteUrl)
          return
        }
        if (!this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['加分材料'], submiteUrl)
          return
        }
        if (this.form.hasEducation) {
          _this.$emit('next', _this.appInfoDataType['学历信息'], submiteUrl)
          return
        }
      })
    },
    async submitStore() {
      await this.$emit(
        'submit',
        '/api/services/app/JZZJFApi/SaveApplicantMarriageInfo',
        0,
        '保存成功'
      )
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(
      response,
      file,
      fileList,
      property,
      isArray,
      isReadIdInfoAfter,
      readIdInfoAfterToView
    ) {
      this.$emit(
        'handleSuccess',
        response,
        file,
        fileList,
        property,
        isArray,
        isReadIdInfoAfter,
        readIdInfoAfterToView
      )
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    openQrCodeUpload(property, isArray, isReadInfo, readIdInfoAfterToView) {
      this.$emit('openQrCodeUpload', property, isArray, isReadInfo, readIdInfoAfterToView)
    },
    //预览
    handleView(guid) {
      this.$emit('handleView', guid)
    },
    //文件大小超出
    handleMaxSize(file) {
      this.$emit('handleMaxSize', file)
    },
    //
    updateProgress(event, file, fileList, name) {
      // this.percent = fileInfo.percent * 0.01
      this.$refs[name + 'Upload'].style.display = 'none'
      this.$refs[name].updateShow(true)
      this.$refs[name].updateProgress(Math.round(event.percent)) //=fileInfo.percent * 0.01

      this.$refs[name + 'Upload'].show = event.percent == 100
      // if (event.percent == 100) {
      //   this.$refs[name].updateShow(false)
      //   this.$refs[name + 'Upload'].style.display = 'block'
      // }
    },
  },
}
</script>